import { Flag, Pencil } from "components";
import { Parking } from "helpers";

interface ParkingTableDataOptionsProps {
  parking: Parking;
  onFlag: (parking: Parking) => void;
  onEdit: (parking: Parking) => void;
}

export const ParkingTableDataOptions = ({ parking, onFlag, onEdit }: ParkingTableDataOptionsProps) => {
  return (
    <div className="flex items-center justify-center space-x-3 bg-primary/5 py-5">
      <Pencil onClick={() => onEdit(parking)} />
      {/* <Flag className={"text-primary"} onClick={() => onFlag(parking)} /> */}
    </div>
  );
};
